'use client';

import { HTMLAttributes, ReactNode } from 'react';

interface DrawerTitleProps extends HTMLAttributes<HTMLHeadElement> {
  children: ReactNode;
}

/**
 * 共通モーダルタイトル
 * @param param0
 * @returns
 */
export default function DrawerTitle({ children, className, ...rest }: DrawerTitleProps) {
  const defaultClassName = 'text-sm italic font-semibold text-gray-500 dark:text-white';

  return (
    <h3 className={`${defaultClassName} ${className || ''}`} {...rest}>
      {children}
    </h3>
  );
}
